module.exports = __webpack_public_path__ + "img/5.c974e01a.png";